import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const initialState = {
    isLoading: false,
    error: null,
    franchiseThemePages: [],
    franchiseThemePage: null,
};

const slice = createSlice({
    name: "franchiseThemePage",
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET Franchise Theme Page
        getFranchiseThemePagesSuccess(state, action) {
            state.isLoading = false;
            state.franchiseThemePages = action.payload;
        },

        // GET Franchise Theme Page
        getFranchiseThemePageSuccess(state, action) {
            state.isLoading = false;
            state.franchiseThemePage = action.payload;
        },
    },
});

// Reducer
export default slice.reducer;

// Actions
// export const {
// } = slice.actions;

// ----------------------------------------------------------------------

export function getFranchiseThemePages(franchiseId, franchiseUserId) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const params = new URLSearchParams({
                franchiseId,
                franchiseUserId,
                limit: '100000',
            });
            const url = `${backendUrl}/franchiseThemePage?${params.toString()}`;
            const response = await axios.get(url);
            dispatch(slice.actions.getFranchiseThemePagesSuccess(response.data.results));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}



// ----------------------------------------------------------------------

export function getFranchiseThemePage(franchiseThemePageId) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(
                `${backendUrl}/franchiseThemePage/${franchiseThemePageId}`
            );
            dispatch(slice.actions.getFranchiseThemePageSuccess(response.data));
        } catch (error) {
            console.error(error);
            dispatch(slice.actions.hasError(error));
        }
    };
}
